import * as React from 'react';
import { IListViewFieldColumn } from "../../../../../services/ViewService";
import { Item } from '../../../../common/sectionsControl/uiControls/InsightsAttentionRequired';

const Priority = (props: IListViewFieldColumn<Item>) => props.entity.isPriority ? "High" : 'Low';
export default Priority;

export const getValue = (item: Item) => (+item.isPriority) + item.createdDate.toISOString();
export const getSearchValue = (item: Item) => item.isPriority ? "High" : 'Low';